import { render, staticRenderFns } from "./otpForm.vue?vue&type=template&id=0755e297&scoped=true&"
import script from "./otpForm.vue?vue&type=script&lang=js&"
export * from "./otpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0755e297",
  null
  
)

export default component.exports